import { render, staticRenderFns } from "./jfcity.vue?vue&type=template&id=77f8c394&scoped=true"
import script from "./jfcity.vue?vue&type=script&lang=js"
export * from "./jfcity.vue?vue&type=script&lang=js"
import style0 from "./jfcity.vue?vue&type=style&index=0&id=77f8c394&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f8c394",
  null
  
)

export default component.exports